import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31238802"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Role:", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Organization:", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { style: {"display":"flex","justify-content":"space-between","align-items":"end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, "Edit user: " + _toDisplayString(_ctx.selectedUser.user.givenName), 1),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(),
      _withDirectives(_createElementVNode("select", {
        class: _normalizeClass([_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light', "stepper-input"]),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUser.user.role) = $event)),
        id: "role"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
          return (_openBlock(), _createElementBlock("option", {
            key: role,
            style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
            value: role
          }, _toDisplayString(role), 13, _hoisted_4))
        }), 128))
      ], 2), [
        [_vModelSelect, _ctx.selectedUser.user.role]
      ]),
      _hoisted_5,
      _createTextVNode(),
      _withDirectives(_createElementVNode("select", {
        class: _normalizeClass([_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light', "stepper-input"]),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUser.user.group) = $event)),
        id: "role"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups.groups, (group) => {
          return (_openBlock(), _createElementBlock("option", {
            key: group,
            style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
            value: group.cn
          }, _toDisplayString(group.cn), 13, _hoisted_6))
        }), 128))
      ], 2), [
        [_vModelSelect, _ctx.selectedUser.user.group]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('back'))),
        class: "cancel"
      }, "Back"),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('confirm', _ctx.selectedUser))),
        class: "confirm"
      }, "Confirm")
    ])
  ]))
}